var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
import { loadFlightControlActionTypes, loadTrafficFiltersActionTypes } from "./SearchFilters.ducks.js";
import { loadIsolationGroupsEpicReducer } from "./SearchFilters.epics.js";
const defaultSearchFilterReducerState = {
  configByManagementGroup: {}
};
const defaultConfigReducerState = {
  flightControl: getDefaultAsyncWrapperObj(),
  trafficFilters: getDefaultAsyncWrapperObj(),
  isolationGroups: getDefaultAsyncWrapperObj()
};
const configReducer = (state = defaultConfigReducerState, action) => {
  switch (action.type) {
    case loadTrafficFiltersActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        trafficFilters: __spreadProps(__spreadValues({}, state.trafficFilters), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadTrafficFiltersActionTypes.LOADED:
      const mgFilterResult = action;
      return __spreadProps(__spreadValues({}, state), {
        trafficFilters: mgFilterResult.payload.result
      });
    case loadFlightControlActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        flightControl: __spreadProps(__spreadValues({}, state.flightControl), {
          status: AsyncRequestStatus.Pending
        })
      });
    case loadFlightControlActionTypes.LOADED:
      const mgFlightControlResult = action;
      return __spreadProps(__spreadValues({}, state), {
        flightControl: mgFlightControlResult.payload.result
      });
    default:
      return state;
  }
};
const searchFilterReducer = (state = defaultSearchFilterReducerState, action) => {
  var _a;
  state = loadIsolationGroupsEpicReducer.reduxChange(state, action);
  const mgKey = ((_a = action == null ? void 0 : action.payload) == null ? void 0 : _a.managementGroup) || "NA";
  const configState = state.configByManagementGroup[mgKey];
  if (!!mgKey) {
    return __spreadProps(__spreadValues({}, state), {
      configByManagementGroup: __spreadProps(__spreadValues({}, state.configByManagementGroup), {
        [mgKey]: configReducer(configState, action)
      })
    });
  }
  return __spreadValues({}, state);
};
export {
  configReducer,
  searchFilterReducer as default,
  defaultConfigReducerState,
  defaultSearchFilterReducerState,
  searchFilterReducer
};
//# sourceMappingURL=SearchFilters.reducer.js.map
